import { render, staticRenderFns } from "./ProcedureFee.vue?vue&type=template&id=2fcd600a&"
import script from "./ProcedureFee.vue?vue&type=script&lang=js&"
export * from "./ProcedureFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports